import { TGetOrderResponse } from '@p2p/services';

// P2P-3048: название банка плательщика (client_bank_code от мерчанта) в
// родительном падеже — для текстов формы оплаты по QR: «Откройте приложение
// Сбербанка», «в приложении Сбербанка». Коды — те же, что в BANK_IDS
// (SelectBank.constants), названия — по таблице из задачи.
export const CLIENT_BANK_NAMES_GENITIVE = {
  sber: 'Сбербанка',
  alfa: 'Альфа Банка',
  vtb: 'ВТБ Банка',
  tbank: 'Т-Банка',
  mts: 'МТС Банка',
  gazprom: 'Газпромбанка',
  ros_selxoz: 'Россельхозбанка',
  mkb: 'МКБ',
  sovkom: 'Совкомбанка',
  dom_rf: 'Банка Дом-РФ',
  raiffaizen: 'Райффайзен Банка',
  rossiya: 'Банка Россия',
  ozon: 'Озон Банка',
  psb: 'ПСБ Банка',
  yoomoney: 'Yoomoney',
  wb: 'Вайлдберриз Банка',
  tcell: 'TCell',
  yandex: 'Яндекс Банка',
  uralsib: 'Уралсиб Банка',
} as const;

// Только для реквизита с qr_invoice: на тот же экран попадают заявки с
// invoice_url (Phoneix) и Сбер на банки Узбекистана — у них тексты остаются
// обезличенными. Код сравниваем без учёта регистра и пробелов, как в
// getClientBankId; пустой или неизвестный код — null, текст не меняется.
export const getClientBankNameGenitive = (order: TGetOrderResponse): string | null => {
  if (!order.requisite.qr_invoice) {
    return null;
  }
  const code = order.client_bank_code?.trim().toLowerCase();
  if (!code || !Object.prototype.hasOwnProperty.call(CLIENT_BANK_NAMES_GENITIVE, code)) {
    return null;
  }
  return CLIENT_BANK_NAMES_GENITIVE[code as keyof typeof CLIENT_BANK_NAMES_GENITIVE];
};
